import {MenuItemDef} from "@ag-grid-community/core";

// Context-menu factory for the "Snooze indicator" row action in Manifest Details, wired into
// ManifestDetailsContextMenu behind the `backendColorRules` flag. DP-3070 connected it to the
// snoozeIndicator mutation (through a confirmation dialog); the options are Jake's, 2026-09-30.

export enum SnoozeIndicatorMenuText {
  SnoozeIndicator = "Snooze indicator"
}

const SNOOZE_OPTIONS_MINUTES = [15, 30, 60, 180];

type GetSnoozeIndicatorMenuItemDefArgs = {
  disabled?: boolean;
  onSnooze: (minutes: number) => void;
};

export const getSnoozeIndicatorMenuItemDef = ({disabled, onSnooze}: GetSnoozeIndicatorMenuItemDefArgs): MenuItemDef => {
  return {
    name: SnoozeIndicatorMenuText.SnoozeIndicator,
    disabled: disabled ?? false,
    subMenu: SNOOZE_OPTIONS_MINUTES.map<MenuItemDef>((minutes) => ({
      name: `${minutes} minutes`,
      action: () => onSnooze(minutes)
    }))
  };
};
